export default class AuthService {
  constructor($http, $state, SessionService) {
    'ngInject';

    Object.assign(this, { $http, $state, SessionService });
  }

  get isLoggedIn() {
    return this.SessionService.user != null && this.SessionService.authToken != null;
  }

  get isSysAdmin() {
    if (!this.SessionService.user) {
      return false;
    }

    return this.SessionService.user.UserType === 'SystemAdministrator';
  }

  get isCompanyAdmin() {
    if (!this.SessionService.user) {
      return false;
    }

    return this.SessionService.user.UserType === 'Member'
      && this.SessionService.user.LevelOfAccess === 3;
  }

  get isRegulator() {
    if (!this.SessionService.user) {
      return false;
    }

    return this.SessionService.user.UserType === 'Regulator';
  }

  get isRegulatorAdmin() {
    return this.isRegulator && this.SessionService.user.LevelOfAccess === 3;
  }

  get isUser() {
    if (!this.SessionService.user) {
      return false;
    }

    return this.SessionService.user.UserType === 'Member'
      && this.SessionService.user.LevelOfAccess === 1;
  }

  getUserInfo() {
    return this.$http.get('/api/account/user_info');
  }

  login(credentials) {
    const data = `grant_type=password&username=${encodeURIComponent(
      credentials.userName
    )}&password=${encodeURIComponent(credentials.password)}`;

    return this.$http.post('/token', data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((r) => {
      this.SessionService.authToken = r.data.access_token;

      return this.$http.get('/api/account/user_info');
    }).then((r) => {
      this.SessionService.user = r.data;
    });
  }

  logout() {
    this.$state.go('login');
    this.SessionService.destroy();
  }

  forgotPassword(userName) {
    return this.$http.post(`/api/account/forgot_password?userName=${userName}`);
  }

  getAccessLevels() {
    const accessLevels = [{
      id: 1,
      desc: 'Level 1'
    }, {
      id: 2,
      desc: 'Level 2'
    }, {
      id: 3,
      desc: 'Level 3'
    }];

    return accessLevels;
  }
}




// WEBPACK FOOTER //
// ./services/auth.service.js